"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseSheetsCopyInfo = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _snakeCase = _interopRequireDefault(require("lodash/snakeCase"));
var LocaleUtil = _interopRequireWildcard(require("./locales"));
var _excluded = ["name"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var SHEETS_COPY_STEPS = {
  COPY_ROLE_PERMISSIONS: 'COPY_ROLE_PERMISSIONS'
};
var parseSheetsCopyInfo = exports.parseSheetsCopyInfo = function parseSheetsCopyInfo(copyInfo) {
  var _stepDetail, _stepDetail$data;
  if ((0, _isEmpty["default"])(copyInfo)) return copyInfo;
  if ((copyInfo === null || copyInfo === void 0 ? void 0 : copyInfo.currentStep) !== SHEETS_COPY_STEPS.COPY_ROLE_PERMISSIONS) return copyInfo;
  if ((0, _isEmpty["default"])(copyInfo === null || copyInfo === void 0 ? void 0 : copyInfo.stepDetails)) return copyInfo;
  var data = (0, _extends2["default"])({}, copyInfo);
  var stepDetail;
  var stepDetailIndex = -1;
  if (Array.isArray(data.stepDetails)) {
    stepDetailIndex = data.stepDetails.findIndex(function (_ref) {
      var name = _ref.name;
      return name === SHEETS_COPY_STEPS.COPY_ROLE_PERMISSIONS;
    });
    if (stepDetailIndex >= 0) stepDetail = data.stepDetails[stepDetailIndex];
  } else {
    stepDetail = data.stepDetails;
  }
  var failRoles = (_stepDetail = stepDetail) === null || _stepDetail === void 0 ? void 0 : (_stepDetail$data = _stepDetail.data) === null || _stepDetail$data === void 0 ? void 0 : _stepDetail$data.failRoles;
  if (Array.isArray(failRoles) && failRoles.length > 0 && data.stepDetails) {
    var localizedRoles = failRoles.map(function (_ref2) {
      var name = _ref2.name,
        rest = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
      return (0, _extends2["default"])({}, rest, {
        name: LocaleUtil.translate("userRoles.".concat((0, _snakeCase["default"])(name)), name)
      });
    });
    if (stepDetailIndex >= 0) {
      data.stepDetails[stepDetailIndex].data.failRoles = localizedRoles;
    } else {
      var _data$stepDetails;
      if ('data' in data.stepDetails && (_data$stepDetails = data.stepDetails) !== null && _data$stepDetails !== void 0 && _data$stepDetails.data) {
        data.stepDetails.data.failRoles = localizedRoles;
      }
    }
  }
  return data;
};